import ElevatePageTemplate from '@/templates/ElevatePageTemplate/ElevatePageTemplate'

function ElevatePage(): JSX.Element {
  return <ElevatePageTemplate />
}

export default ElevatePage
